import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AQ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AQ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#5196ED"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AQ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AQ_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.718 7.894s2.064 1.132 2.351 1.445c.287.314.747 1.464 1.464.814.718-.65 1.435-.145 1.435-1.181s1.071-3.44 2.625-2.838c1.555.603 2.832.226 3.19.467.36.24 1.22 1.437 1.89 1.437.67 0 1.004.699 1.052 1.71.048 1.013-.215 1.11.406 1.23.622.12.861.579.55 1.18-.31.603-.286.338-.239.965.048.626-.621 4.321-2.678 4.683-2.056.361-4.006.168-3.48-.53.527-.7 1.255-1.503.179-1.672-1.076-.169-1.754-.313-2.83-.023-1.077.289-2.2.746-2.87-.12-.67-.868-.526-1.495-1.076-1.905-.55-.41-1.22-.337-.67-1.132.55-.795 1.004-.498.55-1.125-.454-.626-2.169-.9-2.169-1.525 0-.627-1.09-2 .32-1.88z",
      fill: "#F5F8FB"
    }
  )))
);
export {
  t as default
};
